import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

export default function SupportThanksPage() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");

  return (
    <div className="max-w-3xl mx-auto px-5 sm:px-8 py-16" data-testid="support-thanks-page">
      <section className="paper-card-elevated rounded-sm p-7 sm:p-9 text-center">
        <CheckCircle2 className="w-10 h-10 mx-auto mb-4 text-[hsl(var(--accent-green))]" />
        <div className="section-label mb-3">Support received</div>
        <h1 className="hero-title text-3xl sm:text-4xl mb-4">
          Thank you — you&rsquo;re helping keep Measure X-Ray independent and ad-free.
        </h1>
        <p className="text-sm sm:text-base text-[hsl(var(--ink-2))] leading-relaxed max-w-xl mx-auto">
          Stripe will handle the payment receipt. Measure X-Ray keeps the public product free,
          quiet, and focused on voters instead of ads or donor data.
        </p>
        {sessionId && (
          <div className="mt-5 text-[10px] font-mono text-[hsl(var(--ink-muted))] break-all" data-testid="support-session-id">
            Session: {sessionId}
          </div>
        )}
        <div className="mt-8 flex items-center justify-center gap-2 flex-wrap">
          <Link to="/" className="pill-btn pill-btn-primary" data-testid="support-thanks-home-link">
            Start a new scan
          </Link>
          <Link to="/measures" className="pill-btn pill-btn-ghost" data-testid="support-thanks-measures-link">
            Latest measures
          </Link>
        </div>
      </section>
    </div>
  );
}
